import Pdf3 from "./other/em3_justified_CR.pdf";

const NewsData = [
    {
      date: "October 2026",
      eventDescription: (
        <div>
          <p>We will co-organize a Birds of a Feather (BoF) session at EMNLP 2026 on explainable authorship verification and style (26.10).</p>
        </div>
      ),
    },
    {
    date: "October 2026",
    eventDescription: (
      <div>
        <p>One paper accepted at the Journal of "Computational Linguistics" (CL):</p>
        <ul>
          <li> <a class="link" href="https://arxiv.org/abs/2509.07274"> LLM Analysis of 150+ years of German Parliamentary Debates on Migration Reveals Shift from Post-War Solidarity to Anti-Solidarity in the Last Decade</a> </li>
        </ul>
      </div>
    ),
  },
  {
    date: "September 2026",
    eventDescription: (
      <div>
        <p>One paper accepted at AACL 2026:</p>
        <ul>
          <li> <a class="link" href="https://arxiv.org/abs/2610.15661"> Feedback as an Interface: Controlling Form and Detail in LLM Translation Refinement</a> </li>
        </ul> 
      </div>
    ),
  },
  {
    date: "August 2026",
    eventDescription: (
      <div>
        <p>Five papers (+1) accepted at EMNLP 2026:</p>
        <ul>
          <li> <a class="link" href={Pdf3}>Justification of Emotional Appeal in Computational Argumentation</a> </li>
          <li> <a class="link" href="https://arxiv.org/abs/2606.02255v3"> Who Annotates in NLP? A Large-scale Assessment of Human Annotation Reporting between 2018 and 2025 </a></li>
          <li> <a class="link" href="https://pub.uni-bielefeld.de/record/3019940"> Syntactic complexity convergence in dialogue: Analysis of the phenomenon and application to LLM detection </a> </li>
          <li> <a class="link" href="https://arxiv.org/abs/2606.09655"> Beyond Accuracy: Community Perspectives on Machine Translation </a></li>
          <li> <a class="link" href="https://arxiv.org/abs/2605.29897"> ExCAM: Explainable Cultural Awareness Metrics </a></li>
          <li> <a class="link" href="https://direct.mit.edu/tacl/article/doi/10.1162/TACL.a.699/137204/CROC-Evaluating-and-Training-T2I-Metrics-with"> (TACL) CROC: Evaluating and Training T2I Metrics with Pseudo- and Human-Labeled Contrastive Robustness Checks</a> </li>
        </ul>
      </div>
    ),
  },
  {
    date: "June 2026",
    eventDescription: (
      <div>
        <p>Two papers accepted at ACL 2026:</p>
        <ul>
          <li> <a class="link" href="https://aclanthology.org/2026.findings-acl.2030"> Beyond Reproduction: A Paired-Task Framework for Assessing LLM Comprehension and Creativity in Literary Translation </a> </li>
          <li> <a class="link" href="https://aclanthology.org/2026.findings-acl.1991"> GerAV: Towards New Heights in German Authorship Verification using Fine-Tuned LLMs on a New Benchmark </a> </li>
        </ul>
      </div>
    ),
  },
  {
      date: "April 2026",
      eventDescription: (
        <div>
          <p>One paper accepted at ACM Computing Surveys:</p>
          <ul>
            <li> <a class="link" href="https://arxiv.org/abs/2502.05151">Transforming Science with Large Language Models: A Survey on AI-assisted Scientific Discovery, Experimentation, Content Generation, and Evaluation</a> </li>
          </ul>
        </div>
      ),
    },
  {
    date: "March 2026",
    eventDescription: (
      <div>
        <p>Outstanding paper award at EACL 2026 for:</p>
        <ul>
          <li> <a class="link" href="https://arxiv.org/abs/2510.09695"> Emotionally Charged, Logically Blurred: AI-driven Emotional Framing Impairs Human Fallacy Detection</a> </li>
        </ul>
      </div>
    ),
  },
  {
      date: "March 2026",
      eventDescription: (
        <div>
          <p>One paper accepted at PLOS One:</p>
          <ul>
            <li> <a class="link" href="https://arxiv.org/abs/2402.11549">Syntactic Language Change in English and German: Metrics, Parsers, and Convergences </a> </li>
          </ul>
        </div>
      ),
    },
  {
      date: "March 2026",
      eventDescription: (
        <div>
          <p>One paper accepted at ACM Computing Surveys:</p>
          <ul>
            <li> LLLMs: A Data-Driven Survey of Evolving Research on Limitations of Large Language Models </li>
          </ul>
        </div>
      ),
    },
  {
      date: "March 2026",
      eventDescription: (
        <div>
          <p>One paper accepted at CVPR 2026:</p>
          <ul>
            <li> SCIEval: Evaluating and Benchmarking the Faithfulness of Scientific Image Generation and Interpretation with Large Multimodal Models </li>
          </ul>
        </div>
      ),
    },
    {
      date: "January 2026",
      eventDescription: (
        <div>
          <p>One paper accepted at ICLR 2026:</p>
          <ul>
            <li> TikZilla: Scaling Text-to-TikZ with High-Quality Data and Reinforcement Learning </li>
          </ul>
        </div>
      ),
    },
    {
      date: "January 2026",
      eventDescription: (
        <div>
          <p>One paper accepted at TACL 2026:</p>
          <ul>
            <li> <a class="link" href="https://arxiv.org/abs/2505.11314"> CROC: Evaluating and Training T2I Metrics with Pseudo- and Human-Labeled Contrastive Robustness Checks (v1)</a> </li>
          </ul>
        </div>
      ),
    },
   {
    date: "January 2026",
    eventDescription: (
      <div>
        <p>One paper accepted at EACL 2026:</p>
        <ul>
          <li> <a class="link" href="https://arxiv.org/abs/2510.09695"> Emotionally Charged, Logically Blurred: AI-driven Emotional Framing Impairs Human Fallacy Detection</a> </li>
        </ul>
      </div>
    ),
  },
  {
    date: "December 2025",
    eventDescription: (
      <div><p>New tutorial accepted at EACL 2026: AI-assisted Scientific Discovery, Experimentation, Content Generation, and Evaluation. Joint with Yufang Hou, Wei Zhao, Anne Lauscher, Yong Cao.</p></div>
      ),
    },
  {
    date: "November 2025",
    eventDescription: (
      <div>
        <p>One paper accepted at AACL 2025:</p>
        <ul>
          <li> <a class="link" href="https://arxiv.org/abs/2504.02106"> ContrastScore: Towards Higher Quality, Less Biased, More Efficient Evaluation Metrics with Contrastive Evaluation</a> </li>
        </ul>
      </div>
    ),
  },
  {
    date: "September 2025",
    eventDescription: (
      <div>
        <p>New grant "Conceptualizing Reconfiguration for Empirical Research" accepted (as part of the DFG-Forschungsgruppe extension proposal RISS, spokesperson: Daniela Grunow, <a href="https://gepris.dfg.de/gepris/projekt/439346934">https://gepris.dfg.de/gepris/projekt/439346934</a>). In it, we will use LLMs to annotate Party Manifestos across time and different countries regarding changes in politicization.</p>
      </div>
    ),
  },
  {
    date: "August 2025",
    eventDescription: (
      <div>
        <p>Three papers accepted at EMNLP 2025:</p>
        <ul>
          <li> <a class="link" href="https://arxiv.org/abs/2503.00847"> Argument Summarization and its Evaluation in the Era of Large Language Models </a> </li>
          <li> <a class="link" href="https://arxiv.org/abs/2412.12318"> Graph-Guided Textual Explanation Generation Framework </a> </li>
          <li> <a class="link" href="https://arxiv.org/abs/2505.05423"> LiTransProQA: an LLM-based Literary Translation evaluation metric with Professional Question Answering </a> </li>
        </ul>
      </div>
    ),
  },
  {
    date: "July 2025",
    eventDescription: (
      <div>
        <p>One paper accepted at IEEE GACLM 2025:</p>
        <ul>
          <li> <a class="link" href="https://arxiv.org/abs/2503.02756"> BatchGEMBA: Token-Efficient Machine Translation Evaluation with Batched Prompting and Prompt Compression </a> </li>
        </ul>
      </div>
    ),
  },
  {
    date: "July 2025",
    eventDescription: (
      <div>
        <p>New UTN internal grant "FoMoMath: Collaborative Foundation Models for Mathematics" accepted (led by Christoph Hertrich, Yuki Asano and Steffen Eger). In it, we will explore novel AI and LLM based solutions for mathematics, especially discrete geometry.</p>
      </div>
    ),
  },
  {
    date: "June 2025",
    eventDescription: (
      <div>
        <p>One paper accepted at ICCV 2025:</p>
        <ul>
          <li> <a class="link" href="https://arxiv.org/abs/2503.11509"> TikZero: Zero-Shot Text-Guided Graphics Program Synthesis</a>  </li>
        </ul>
      </div>
    ),
  },
  {
    date: "June 2025",
    eventDescription: (
      <div>
        <p>One paper accepted at JLM (Journal of Language Modeling):</p>
        <ul>
          <li> <a class="link" href="https://arxiv.org/abs/2409.03659"> LLM-based multi-agent poetry generation in non-cooperative environments</a>  </li>
        </ul>
      </div>
    ),
  },
  {
    date: "May 2025",
    eventDescription: (
      <div>
        <p>We welcome our new group members Subhadeep Roy! He will pursue his PhD working on Multi-modal Evaluation Metrics.</p>
      </div>
    ),
  },
   {
    date: "May 2025",
    eventDescription: (
      <div>
        <p>Two workshops accepted at IJCNLP-AACL 2025: (1) <b>SciProdLLM</b>, <i>The 1st Workshop on Towards Human-LLM Collaboration for Ethical and Responsible Science Production</i> and
          (2) <b>Eval4NLP</b>,  the <i>Fifth Workshop on Evaluation \& Comparison of NLP Systems</i>.</p>
      </div>
    ),
  },
  {
    date: "May 2025",
    eventDescription: (
      <div>
        <p>One paper accepted at ACL 2025:</p>
        <ul>
          <li> <a class="link" href="https://arxiv.org/abs/2503.00024"> Do Emotions Really Affect Argument Convincingness? A Dynamic Approach with LLM-based Manipulation Checks</a>  </li>
        </ul>
      </div>
    ),
  },
  {
    date: "May 2025",
    eventDescription: (
      <div>
        <p>Outstanding paper award at NAACL 2025 for <a class="link" href="https://aclanthology.org/2025.naacl-long.548/"> How Good Are LLMs for Literary Translation, Really? Literary Translation Evaluation with Humans and LLMs</a>. </p>
      </div>
    ),
  },
  {
    date: "April 2025",
    eventDescription: (
      <div>
        <p>New grant "ALiAS" accepted (joint with a German law enforcement agency). In it, we will investigate authorship verification in German social media with LLMs.</p>
      </div>
    ),
  },
  {
    date: "March 2025",
    eventDescription: (
      <div>
        <p>New grant "Collaborative Scientific Research and Discovery with AI" accepted (joint with Wei Zhao and Jennifer D'Souza). In it, we will annotate scientific papers with humans and LLMs for various aspects including multimodal content.</p>
      </div>
    ),
  },
  {
    date: "Feb 2025",
    eventDescription: (
      <div>
        <p>We welcome our new group members Christian Greisinger! He will pursue his PhD working on NLP for science.</p>
      </div>
    ),
  },
  {
    date: "January 2025",
    eventDescription: (
      <div>
        <p>Two papers accepted at NAACL 2025:</p>
        <ul>
          <li> <a class="link" href="https://arxiv.org/abs/2412.16120"> PromptOptMe: Error-Aware Prompt Compression for LLM-based MT Evaluation Metrics </a>  </li>
          <li> <a class="link" href="https://arxiv.org/abs/2410.18697"> How Good Are LLMs for Literary Translation, Really? Literary Translation Evaluation with Humans and LLMs </a> </li>
        </ul>
      </div>
    ),
  },
  {
    date: "January 2025",
    eventDescription: (
      <div>
        <p>One paper accepted at ICLR 2025: <a class="link" href="https://arxiv.org/abs/2412.02368"> ScImage: How Good Are Multimodal Large Language Models at Scientific Text-to-Image Generation? </a> </p>
      </div>
    ),
  },
  {
    date: "December 2024",
    eventDescription: (
      <div>
        <p>New grant "HistoBias" accepted (joint with Simone Ponzetto and Daniela Grunow). In HistoBias, we will analyze social biases over time and in different languages.</p>
      </div>
    ),
  },
  {
    date: "September 2024",
    eventDescription: (
      <div>
        <p>Steffen Eger is now a full (Heisenberg) professor at University of Technology Nuremberg (UTN).</p>
      </div>
    ),
  },
  {
    date: "September 2024",
    eventDescription: (
      <div>
        <p>Our group moves to Nürnberg.</p>
      </div>
    ),
  },
  {
    date: "September 2024",
    eventDescription: (
      <div>
        <p>One paper accepted at NeurIPS 2024: <a class="link" href="https://arxiv.org/abs/2405.15306"> DeTikZify: Synthesizing Graphics Programs for Scientific Figures and Sketches with TikZ </a> </p>
      </div>
    ),
  },
  {
    date: "September 2024",
    eventDescription: (
      <div>
        <p>Four papers accepted at EMNLP 2024:</p>
        <ul>
          <li> <a class="link" href="https://pub.uni-bielefeld.de/record/2992769"> Fine-Grained Detection of Solidarity for Women and Migrants in 155 Years of German Parliamentary Debates </a>  </li>
          <li> <a class="link" href="https://arxiv.org/abs/2406.14553"> xCOMET-lite: Bridging the Gap Between Efficiency and Quality in Learned MT Evaluation Metrics </a> </li>
          <li> <a class="link" href="https://arxiv.org/abs/2406.15267"> Evaluating Diversity in Automatic Poetry Generation </a> </li>
          <li> <a class="link" href="https://arxiv.org/abs/2406.18528"> PrExMe! Large Scale Prompt Exploration of Open Source LLMs for Machine Translation and Summarization Evaluation </a> </li>
        </ul>
      </div>
    ),
  },
  {
    date: "July 2024",
    eventDescription: (
      <div>
        <p>We thank Google for a new grant to use their multimodal LM PaliGemma.</p>
      </div>
    ),
  },
  {
    date: "May 2024",
    eventDescription: (
      <div>
        <p>We welcome our new group member Yanran Chen! She will pursue her PhD working on convincing argument generation.</p>
      </div>
    ),
  },
  {
    date: "April 2024",
    eventDescription: (
      <div>
        <p>One paper accepted at the Journal of "Computational Linguistics" (CL): </p>
        <a class="link" href="https://arxiv.org/abs/2306.12916">
          Cross-lingual Cross-temporal Summarization: Dataset, Models, Evaluation
        </a>
      </div>
    ),
  },
  {
    date: "March 2024",
    eventDescription: (
      <div>
        <p>One paper accepted at the Journal of "Machine Learning with Applications" (MLWA): </p>
        <a class="link" href="https://arxiv.org/abs/2302.13795">
          ChatGPT: A Meta-Analysis after 2.5 Months
        </a>
      </div>
    ),
  },
  {
    date: "March 2024",
    eventDescription: (
      <div>
        <p>One paper accepted at the Journal of "Argumentation & Computation": </p>
        <a class="link" href="https://arxiv.org/abs/2306.04314">
          Cross-Genre Argument Mining: Can Language Models Automatically Fill in Missing Discourse Markers?
        </a>
      </div>
    ),
  },
  {
    date: "February 2024",
    eventDescription: (
      <div>
        <p>One paper accepted at the "Journal of Machine Learning Research" (JMLR): </p>
        <a class="link" href="https://jmlr.org/papers/v25/22-0416.html">
          Towards Explainable Evaluation Metrics for Machine Translation
        </a>
      </div>
    ),
  },
  {
    date: "January 2024",
    eventDescription: (
      <div>
        <p>One paper accepted at ICLR 2024: </p>
        <a class="link" href="https://arxiv.org/abs/2310.00367">
          AutomaTikZ
        </a>
      </div>
    ),
  },
  {
    date: "January 2024",
    eventDescription: (
      <div>
        <p>One findings paper accepted at EACL 2024: </p>
        <a class="link" href="https://arxiv.org/abs/2212.10469">
          BMX
        </a>
      </div>
    ),
  },
  {
    date: "November 2023",
    eventDescription: (
      <div>
        <p>Our group is moving to Mannheim.</p>
      </div>
    ),
  },
  {
    date: "November 2023",
    eventDescription: (
      <div>
        <p>We conducted the Eval4NLP 2023 shared task and published a <a class="link" href="https://arxiv.org/abs/2310.19792">
          overview paper
        </a> at IJCNLP-AACL 2023.</p>
      </div>
    ),
  },
  {
    date: "November 2023",
    eventDescription: (
      <div>
        <p>One findings paper accepted at EMNLP 2023: </p>
        <a class="link" href="https://arxiv.org/abs/2209.09593">
          EffEval
        </a>
      </div>
    ),
  },
  {
    date: "July 2023",
    eventDescription: (
      <div>
        <p>Honourable mention at ACL 2023: </p>
        <a class="link" href="https://aclanthology.org/2023.acl-long.406/">
          ByGPT5
        </a>
      </div>
    ),
  },
  {
    date: "June 2023",
    eventDescription: (
      <div>
        <p>New PhD member Aida Kostikova: Aida will research limitations of large language models in social and political contexts</p>
      </div>
    ),
  },
  {
    date: "May 2023",
    eventDescription: (
      <div>
        <p>Outstanding paper award at EACL 2023: </p>
        <a class="link" href="https://aclanthology.org/2023.eacl-main.27/">
          UScore
        </a>
      </div>
    ),
  },
  {
    date: "May 2023",
    eventDescription: (
      <div>
        <p>Two papers accepted at ACL 2023: </p>
        <a class="link" href="https://aclanthology.org/2023.acl-long.406/">
          ByGPT5
        </a> and <a class="link" href="https://aclanthology.org/2023.findings-acl.434/">
          Trade-Offs Between Fairness and Privacy in Language Modeling
        </a>.
      </div>
    ),
  },
  {
    date: "Jan 2023",
    eventDescription: (
      <div>
        <p>New DFG grant "EMCONA" accepted (joint with Roman Klinger). In EMCONA, we will analyze the interplay between emotions and convincingness in argumentation.</p>
      </div>
    ),
  },
  {
    date: "July 2022",
    eventDescription: (
      <div>
        <p>New BMBF grant "Metrics4NLG" accepted. In Metrics4NLG, we investigate a novel class of evaluation metrics for text generation systems, aiming at their explainability, efficiency, and robustness. "Metrics4NLG" is an interdisciplinary project involving applications in the humanities (e.g., evaluation of poetry generation systems).</p>
      </div>
    ),
  },
  /*{
    date: "June 2022",
    eventDescription: (
      <div>
        <p>One paper accepted at the Journal of Social Computing: </p>
        <a class="link" href="https://ieeexplore.ieee.org/stamp/stamp.jsp?arnumber=9832842">
          Measuring Social Solidarity During Crisis: The Role of Design Choices
        </a>
      </div>
    ),
  },
  {
    date: "Sep 2021",
    eventDescription: (
      <div>
        <p>One paper accepted at EMNLP 2021: </p>
        <a class="link" href="https://aclanthology.org/2021.emnlp-main.701.pdf">
          Global Explainability
        </a>
      </div>
    ),
  },
  */
];

export default NewsData;
